<template>
  <v-dialog
      v-model="dialog"
      scrollable
      width="400"
  >
    <v-card>
      <v-card-title>Leistungsgruppe auswählen</v-card-title>
      <v-card-title>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Suchen"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="dialog">
        <v-list-item-group v-model="selectedItem" color="primary" style="max-height: 450px;">
          <v-list-item
              v-for="item in filteredList"
              :key="item.id"
              :value="item"
          >
              <v-list-item-content>
                <v-list-item-title :ref="item.id">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog = false; $emit('select', selectedItem)"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectAufisnDialog",
  props: {
    legrs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      selected: null,
      search: '',
      selectedItem: null,
      items: [],
    };
  },
  computed: {
    filteredList() {
      if (!this.search) {
        return this.items;
      }
      const searchLower = this.search.toLowerCase();
      return this.items.map(item => {
        if (!item.entries || item.entries.length === 0) {
          return null; // Skip items without entries
        }
        if (item.name.toLowerCase().includes(searchLower)) {
          return {
            ...item
          };
        }
        return null;
      }).filter(Boolean);
    },
    isSubLevelSelected() {
      if (!this.selectedItem) {
        return false;
      }
      // Check if the selected ID belongs to a sub-level entry
      return this.items.some(item => {
            if (item.entries === undefined) {
              return false;
            }
            return item.entries.some(entry => entry.id === this.selectedItem.id);
          }
      );
    },
  },
  methods: {
    open() {
      this.search = null;
      this.selectedItem = null;
      let items = JSON.parse(JSON.stringify(this.legrs));
      for (let i = 0; i < items.length; i++) {
        items[i].expanded = false;
      }
      this.items = items;
      this.dialog = true;
    }
  },
}
</script>

<style scoped>

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

::v-deep .v-list-item__action {
  margin: 6px 0;
}

::v-deep .v-list-item__content {
  padding: 6px 0;
}

::v-deep .v-list-item {
  min-height: 38px;
  transform: translate(0, 0);
  padding: 0 10px;
}

::v-deep .v-list-group__items {
  padding-left: 18px;
}

</style>
